import type { CanadaPriceBreakdownPricingValues } from "@slfinrtl/ui-bff-routes"
import type { CheckboxGroupFieldProps } from "../../../form/checkbox/CheckboxGroupField"
import type { InputFieldProps } from "../../../form/input/InputField"
import type { RadioGroupFieldProps } from "../../../form/radio/radioGroup/RadioGroupField"

export interface CanadaPriceBreakdownPricingFields {
	accessories?: CheckboxGroupFieldProps
	hasSpareWheel: RadioGroupFieldProps
	minimumPrice: InputFieldProps
	purchasePrice: InputFieldProps
	showLuxuryTax: RadioGroupFieldProps
	vehiclePrice: InputFieldProps
}

type FieldName = keyof CanadaPriceBreakdownPricingValues

const minimumPriceName: FieldName = "minimumPrice"
const purchasePriceName: FieldName = "purchasePrice"
const vehiclePriceName: FieldName = "vehiclePrice"
const hasSpareWheelName: FieldName = "hasSpareWheel"
const showLuxuryTaxName: FieldName = "showLuxuryTax"
const accessoriesName: FieldName = "accessoryIds"

export const canadaPriceBreakdownPricingFieldNames = {
	accessoriesName,
	hasSpareWheelName,
	minimumPriceName,
	purchasePriceName,
	showLuxuryTaxName,
	vehiclePriceName,
}
